import React from "react";
import CustomInput from "./CustomInput";

export default React.lazy(
  () => import("./CustomInput")
) as unknown as typeof CustomInput;
